import { toastService } from "src/libraries/toast";
import { magazineCategoryModel } from "../entity/magazineCategory/MagazineCategoryModel";
import { magazineCategoryService } from "../entity/magazineCategory/MagazineCategoryService";
import { GetMagazineCategoriesDto } from "../entity/magazineCategory/dto/list-categories-dto";

export const getMagazineCategoriesUseCase = async (body?: GetMagazineCategoriesDto) => {
    try {
        const response = await magazineCategoryService.list(body);
        if (response?.isError) {
            toastService.onError('Some error');
        } else {
            magazineCategoryModel.magazineCategories = response.data;
        }
    } catch (error) {
        console.warn('getMagazineCategoriesUseCase: ', error);
    }
}